<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="main-box">
      <div class="main-content">{{ $t('fany.text1') }}</div>
    </div>
    <div class="main-box2">
      <div class="main main-list">
        <div class="list-item" v-for="(item,index) in $t('fany.list1')" :key=index>
          <div class="title">{{item.title}}</div>
          <div class="text" :class="index%2===1?'text2':''" v-for="(i,k) in item.info" :key=k>{{i}}</div>
        </div>
      </div>
    </div>
    <div class="main-box3">
      <div class="main">
        <div class="name">{{ $t('fany.text2') }}</div>
        <div class="box3-fa">
          <div class="fa-item" v-for="(item,index) in $t('fany.list2')" :key=index>
            <img class="fa-img" :src="item.url">
            <div class="fa-name">{{item.title}}</div>
            <div class="fa-grid">
              <div v-for="(i,k) in item.info" :key=k>{{ i }} </div>
            </div>
          </div>
          <div class="fa-item">q</div>
          <div class="fa-item">q</div>
        </div>
        <div class="name">{{ $t('fany.text3') }}</div>
        <div class="box3-al">
          <div class="al-name">{{$t('fany.list3')[ix].title}}</div>
          <div class="al-box">
            <img class="al-img" :src="$t('fany.list3')[ix].url">
            {{$t('fany.list3')[ix].info}}
          </div>
          <div class="al-page">
            <div class="page-item " v-for="(item,i) in $t('fany.list3')" :key="i" :class="ix===i? 'item2':''" @click="ix=i">
              {{i+1}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {
      list1:[
        {
          title:'行业痛点',
          info:['需要面临极端温度、大风、降雨及降雪等恶劣环境条件','传统巡检方式无法突破时空限制，巡检效率低、成本高','传统巡检方式，数据采集不全面，缺乏有效的数据采集方式']
        },
        {
          title:'方案优势',
          info:['中型复合翼无人机具备抗风、抗雨雪天气的能力，可以在复杂气象环境下使用，并且能够在山区、河流、戈壁等多样化地形使用','中型复合翼无人机能够突破时空限制，可以24小时快速进行巡检作业，大幅提升巡检的工作效率','中型复合翼无人机搭载高分辨率摄像头和先进传感器，能够实现对电力设备的高精度监测，提供更详细、更全面的数据信息']
        }
      ],
      list2:[
        {
          url:'/static/images/v2/hyfa/fa_fly.png',
          title:'中型复合翼无人机飞行平台',
          info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
        },
        {
          url:'/static/images/v2/hyfa/fa_rj.png',
          title:'软件产品',
          info:['巡检助手','云巡','Dowell']
        },
        {
          url:'/static/images/v2/hyfa/fa_rwzh.png',
          title:'任务载荷',
          info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
        },
      ],
      list3:[
        {
          url:'/static/images/v2/hyfa/ny_al1.png',
          title:'输电线路无人机防汛应急巡查',
          info:'国网通航使用中型复合翼无人机对安徽池州-九华重要输电线路开展无人机防汛应急巡查，这是国网公司首次采用中大型复合翼无人机开展电网防汛应急巡查任务，通过实时图传、机机中继等方式高效完成各类通道应急巡查任务，为电网安全稳定运行提供了强有力的保障。'
        },
        {
          url:'/static/images/v2/hyfa/ny_al2.png',
          title:'复合翼无人机执行4500米高海拔电网线路巡检',
          info:'大中型无人机高高原示范作业由国网通航公司与国网西藏检修公司联合开展。示范作业使用XXX复合翼无人机执行4500米高海拔电网线路巡检作业，对国网西藏电力的电力系统进行常规激光、夜间激光、灾情应急普查、红外巡视、红外夜巡等多个科目作业，实现了24小时全天候作业。此次作业刷新了国内外多个高原无人机的巡检记录。'
        },
      ],
      ix:0
    };
  },
  mounted() {},
  methods: {

  },
};
</script>

<style scoped lang="stylus">
.template-container {
  width: 100%;
  .main{
    width: 1280px;
  }
  .main-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/hyfa/ny_bg1.png");
    width: 100%;
    height: 22.5vw;
    .main-content{
      font-size: 64px;
      font-weight: 800;
      color: #FFFFFF;
      width: 1280px;
    }
  }
  .main-box2{
    display: flex;
    justify-content: center;
    width: 100%;
    .main-list{
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 20px;
      row-gap: 10px;
    }
    .list-item{
      margin-top: 55px;
      margin-bottom: 50px;
      .title{
        height: 80px;
        font-size: 30px;
        font-weight: 800;
        color: #111111;

      }
      .text{
        line-height: 22px;
        margin-top: 12px;
        box-sizing: border-box;
        padding: 19px;
        display: flex;
        align-items: center;
        height: 121px;
        background: #FFF7F7;
        border: 1px solid #D8D8D8;
        font-size: 16px;
        color: #111111;
        border-radius: 10px;
      }
      .text2{
        background: #F7FFFD;
        border: 1px solid #D8D8D8;
      }
    }
  }
  .main-box3{
    background: #E8E8E8;
    display: flex;
    justify-content: center;
    .name{
      margin-top: 71px;
      margin-bottom: 23px;
      text-align: center;
      color: #111111;
      font-size: 36px;
      font-weight: 600;
    }
    .box3-fa{
      padding: 40px;
      display: flex;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #DCDCDC;
      .fa-item{
        flex: 1;
        margin-left: 20px;
        margin-right: 20px;
      }
      .fa-img{
        border-radius: 10px;
        height: 231px;
      }
      .fa-name{
        margin-top: 14px;
        font-size: 20px;
        font-weight: 600;
        color: #111111;
        margin-bottom: 20px;
      }
      .fa-grid{
        padding-left: 18px;
        border-left:1px solid #F6F6F6;
        color: #3D3D3D;
        font-size: 16px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 20px;
        row-gap: 12px;
      }
    }
    .box3-al{
      margin-bottom: 75px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #DCDCDC;
      padding: 28px;
      .al-name{
        margin-top: 40px;
        margin-bottom: 20px;
        font-size: 32px;
        font-weight: 600;
        color: #1F65FE;
      }
      .al-box{
        border-bottom: 1px solid  #D8D8D8;
        padding-bottom: 40px;
        padding-right: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        color: #383838;
        display: flex;
        .al-img{
          margin-right: 50px;
          width: 580px;
          height: 400px;
        }
      }
      .al-page{
        display: flex;
        .page-item{
          cursor: pointer;
          margin-bottom: -10px;
          text-align: center;
          margin-top: 23px;
          margin-right: 5px;
          width: 48px;
          height: 48px;
          border-radius: 6px;
          font-size: 16px;
          font-weight: 600;
          line-height: 46px;
          border: 1px solid #111111;
        }
        .item2{
          border: 1px solid #1F65FE;
          color: #1F65FE;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    width: 100%;
    .main{
      width: 100%;
    }
    .main-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-size: cover;
      background-position: top;
      background-image: url("/static/images/v2/hyfa/ny_bg1.png");
      width: 100%;
      height: 58.3vw;
      .main-content{
        margin-left: 10px;
        font-size: 50px;
        font-weight: 800;
        color: #FFFFFF;
        width: 100%;
      }
    }
    .main-box2{
      display: flex;
      justify-content: center;
      width: 100%;
      .main-list{
        padding: 0 20px;
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 20px;
        row-gap: 10px;
      }
      .list-item{
        margin-top: 55px;
        margin-bottom: 50px;
        .title{
          font-size: 30px;
          font-weight: 800;
          color: #111111;

        }
        .text{
          line-height: 22px;
          margin-top: 12px;
          box-sizing: border-box;
          padding: 19px;
          display: flex;
          align-items: center;
          height: 121px;
          background: #FFF7F7;
          border: 1px solid #D8D8D8;
          font-size: 16px;
          color: #111111;
          border-radius: 10px;
        }
        .text2{
          background: #F7FFFD;
          border: 1px solid #D8D8D8;
        }
      }
    }
    .main-box3{
      background: #E8E8E8;
      display: flex;
      justify-content: center;
      .name{
        margin-top: 71px;
        margin-bottom: 23px;
        text-align: center;
        color: #111111;
        font-size: 36px;
        font-weight: 600;
      }
      .box3-fa{
        padding: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #DCDCDC;
        .fa-item{
          flex: 1;
          margin-left: 1px;
          margin-right: 1px;
        }
        .fa-img{
          margin-top: 20px;
          border-radius: 10px;
          height: auto;
        }
        .fa-name{
          margin-top: 14px;
          font-size: 20px;
          font-weight: 600;
          color: #111111;
          margin-bottom: 20px;
        }
        .fa-grid{
          margin-bottom: 20px;
          padding-left: 18px;
          border-left:1px solid #F6F6F6;
          color: #3D3D3D;
          font-size: 16px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 20px;
          row-gap: 12px;
        }
      }
      .box3-al{
        margin-bottom: 75px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #DCDCDC;
        padding: 28px;
        .al-name{
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 32px;
          font-weight: 600;
          color: #1F65FE;
        }
        .al-box{
          border-bottom: 1px solid  #D8D8D8;
          padding-bottom: 40px;
          padding-right: 20px;
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
          color: #383838;
          display: flex;
          flex-direction: column;
          .al-img{
            width: 100%;
            height: auto;
            margin-bottom: 20px;
          }
        }
        .al-page{
          display: flex;
          .page-item{
            cursor: pointer;
            margin-bottom: -10px;
            text-align: center;
            margin-top: 23px;
            margin-right: 5px;
            width: 48px;
            height: 48px;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 600;
            line-height: 46px;
            border: 1px solid #111111;
          }
          .item2{
            border: 1px solid #1F65FE;
            color: #1F65FE;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/hyfa/fany.vue